// A tinted header row, as on the data grids. (The template's display: block here broke column
// alignment, which every table had to undo with display: table-header-group.)
export default function tableHead({ tokens }) {
  const tableHead = {
    styleOverrides: {
      root: {
        backgroundColor: tokens["surface-2"],
      },
    },
  };

  return tableHead;
}
